import { useMemo } from 'react';

import { useItemState, indexRoute, newItemRoute, getItemAction, updateItemAction, deleteItemAction } from './utils';

export const productParams = {
	index: ['id', 'sku', 'sku2', 'name', 'clientId', 'preferences', 'createdAt'],
	show: ['id', 'sku', 'sku2', 'name', 'clientId', 'preferences', 'createdAt'],
	create: {
		required: ['sku', 'name'],
		allowed: ['sku', 'sku2', 'name', 'clientId', 'preferences'],
	},
	update: {
		allowed: ['sku', 'sku2', 'name', 'clientId', 'preferences'],
	},
};

const products = {
	index: indexRoute('/products/'),
	newItem: newItemRoute('/products/', { allowedParams: productParams.create.allowed }),
	item: (id, params, { history, lazy } = {}) => {
		const url = `/products/${id}`;
		const [item, setItem] = useItemState(url, params);

		const get = getItemAction(url, { params, setItem });

		const update = updateItemAction(url, {
			allowedParams: productParams.update.allowed,
			item,
			setItem,
			onSuccess: () => get(null, 'update'),
		});

		const del = deleteItemAction(url, { setItem, history });

		useMemo(() => {
			if (!lazy) get();
		}, []);

		return { item, actions: { get, update, delete: del } };
	},
};

export default products;
